const PRODUCTION_URL = 'https://design.prosecaptain.com';
const LOCAL_URL = 'http://localhost:4001';

export const DESIGN_STUDIO_APP_KEY = 'design';

export const getDesignStudioUrl = () => {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
  return isLocalhost ? LOCAL_URL : PRODUCTION_URL;
};

export const DESIGN_STUDIO_URL = PRODUCTION_URL;

export const isDesignStudioOrigin = (url) => {
  if (!url || typeof url !== 'string') return false;
  try {
    const { hostname } = new URL(url);
    return hostname === 'design.prosecaptain.com' || hostname === 'localhost';
  } catch {
    return url.includes('design.prosecaptain.com') || url.includes('localhost:4001');
  }
};
